import { useContext } from "react";
import { useParams } from "react-router";
import { Context } from "../context/DataContext";
import useCustomerBlock from "@shared/hooks/useCustomerBlock";
import RenderDisabledCustomer from "@shared/components/RenderDisabledCustomer";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { UseEmployee } from "@shared/server/fetcher";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import EmployeeNameHeader from "../components/EmployeeNameHeader";
import SubmitButton from "@shared/components/SubmitButton";
import CancelIcon from "@material-ui/icons/Cancel";
import Loading from "@shared/components/Loading";
import RenderBackButton from "@shared/components/RenderBackButton";

const DeleteEmployee = ({ history }) => {
  const { state, deleteEmployee } = useContext(Context);
  const { user } = state;

  const { id: owner_id, id2: employee_id } = useParams();
  const { data: employee, isLoading, mutate } = UseEmployee(owner_id, employee_id);
  // owner_id is the customer_id straight off the URL here.
  const block = useCustomerBlock(owner_id);

  if (isLoading || block.isChecking) return <Loading />;
  if (block.isBlocked) return <RenderDisabledCustomer {...block.disabledProps} />;

  const submitHandlder = async () => {
    await mutate(deleteEmployee({ owner_id, employee_id, deletedBy: user.user_id }, history.replace), {
      populateCache: true,
    });
  };

  return (
    <div className="container mt-5">
      <EmployeeNameHeader user={employee} />

      <Card>
        <CardContent>
          <Typography variant="h5" component="h3" className="text-danger">
            Confirmaci&oacute;n
          </Typography>

          <Typography variant="h6" component="h4" gutterBottom>
            Decea borrar este Empleado?
          </Typography>

          <Typography variant="h6" component="h4" paragraph>
            {employee.fname} {employee.lname}
          </Typography>

          <Box paddingTop={2}>
            <SubmitButton
              autoFetch={false}
              color="secondary"
              text="Eliminar Empleado!"
              startIcon={<CancelIcon />}
              callBack={submitHandlder}
            />
            <div className="mt-4">
              <RenderBackButton />
            </div>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default DeleteEmployee;
